import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "./axios";

const confirmDeposit = createAsyncThunk(
  "payment/confirmDeposit",
  async (data, { rejectWithValue }) => {
    try {
      const headers = { "Content-Type": "application/json" };

      const response = await axios.post(
        "/v1/deposits/confirmDeposit",
        JSON.stringify(data),
        {
          headers,
        }
      );

      return response.data;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err.response.data.message);
    }
  }
);

const confirmC2CDeposit = createAsyncThunk(
  "payment/confirmC2CDeposit",
  async (data, { rejectWithValue }) => {
    try {
      const headers = { "Content-Type": "application/json" };

      const response = await axios.post(
        "/v1/deposits/confirmC2CDeposit",
        JSON.stringify(data),
        {
          headers,
        }
      );
      return response.data;
    } catch (err) {
      console.log("Payment Thunk Error:", err);
      return rejectWithValue(err.response.data);
    }
  }
);

const uploadReceiptC2C = createAsyncThunk(
  "payment/uploadReceiptC2C",
  async ({ transactionId, traderName, media, type }, { rejectWithValue }) => {
    try {
      const headers = { "Content-Type": "application/json" };
      const response = await axios.post(
        "/v1/deposits/uploadReceiptC2C",
        { transactionId, traderName, media, type },
        { headers }
      );
      return response.data;
    } catch (err) {
      console.log("uploadReceiptC2C Thunk Error:", err);
      return rejectWithValue(
        err.response?.data?.message || err.response?.data || err.message
      );
    }
  }
);

export { confirmDeposit, confirmC2CDeposit, uploadReceiptC2C };
